import { BadgeProps, Badge as MuiBadge } from "@mui/material";
import { forwardRef } from "react";

type Props = BadgeProps;

export const Badge = forwardRef<HTMLSpanElement, Props>(({ children, ...props }, ref) => {
  return (
    <MuiBadge ref={ref} {...props}>
      {children}
    </MuiBadge>
  );
});
Badge.displayName = "Badge";
